import { render, staticRenderFns } from "./AlertGrid.vue?vue&type=template&id=2504e934&scoped=true&"
import script from "./AlertGrid.vue?vue&type=script&lang=js&"
export * from "./AlertGrid.vue?vue&type=script&lang=js&"
import style0 from "./AlertGrid.vue?vue&type=style&index=0&id=2504e934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504e934",
  null
  
)

export default component.exports